// extracted by mini-css-extract-plugin
module.exports = {"fullPageModal":"removeCollaborator_fullPageModal__3FHo9","modalContent":"removeCollaborator_modalContent__3B0iT","modalButtons":"removeCollaborator_modalButtons__2sJDE"};